module.exports = __webpack_public_path__ + "media/images/shopify-2025-d8aea063.svg";